import React, { useEffect } from "react";
import "./InvoicePreview.css";
import printInvoice from "./InvoicePrintService";

const InvoicePreview = ({
                          invoiceData,
                          error,
                          saveSuccess,
                          isSubmitting,
                          onClose,
                          onBack,
                          onSave
                        }) => {
  // Trigger print function after successful save
  useEffect(() => {
    if (saveSuccess) {
      // Short delay to ensure success message is shown before printing
      const printTimer = setTimeout(() => {
        printInvoice(invoiceData, { closeAfterPrint: true });
      }, 500);

      return () => clearTimeout(printTimer);
    }
  }, [saveSuccess, invoiceData]);

  return (
      <div className="invp-modal-overlay">
        <div className="invp-preview-container">
          <button
              className="invp-close-btn invp-print-hide"
              onClick={onClose}
              disabled={isSubmitting}
          >
            ×
          </button>

          {/* Invoice Header Info */}
          <div className="invp-header-info">
            <div>
              <p className="invp-invoice-number">Invoice #: {invoiceData.invoiceNo}</p>
              <p className="invp-invoice-date">Date: {invoiceData.date}</p>
              <p className="invp-payment-method">Payment: {invoiceData.paymentMethod}</p>
            </div>
          </div>

          {/* Customer Info */}
          <div className="invp-customer-container">
            <div className="invp-customer-info">
              <p className="invp-bill-to">BILL TO:</p>
              <p className="invp-customer-nic">{invoiceData.customerNIC}</p>
              <p className="invp-customer-name">{invoiceData.customerName}</p>
            </div>
          </div>

          {/* Invoice Items */}
          <table className="invp-preview-table">
            <thead>
            <tr>
              <th>ITEM</th>
              <th>QUANTITY</th>
              <th>UNIT PRICE</th>
              <th>TOTAL</th>
            </tr>
            </thead>
            <tbody>
            {invoiceData.items && invoiceData.items.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>Rs.{parseFloat(item.unitPrice).toFixed(2)}</td>
                  <td>Rs.{parseFloat(item.totalPrice).toFixed(2)}</td>
                </tr>
            ))}
            </tbody>
          </table>

          {/* Invoice Totals */}
          <div className="invp-preview-totals">
            <div className="invp-totals-row">
              <span>Subtotal:</span>
              <span>Rs.{parseFloat(invoiceData.total).toFixed(2)}</span>
            </div>
            <div className="invp-totals-row">
              <span>Discount:</span>
              <span>Rs.{parseFloat(invoiceData.discount).toFixed(2)}</span>
            </div>
            <div className="invp-divider"></div>
            <div className="invp-totals-row invp-grand-total">
              <span>Grand Total:</span>
              <span>Rs.{parseFloat(invoiceData.grandTotal).toFixed(2)}</span>
            </div>
          </div>

          {/* Notes */}
          {invoiceData.notes && (
              <div className="invp-notes">
                <p className="invp-notes-title">Notes:</p>
                <p className="invp-notes-content">{invoiceData.notes || "No additional notes"}</p>
              </div>
          )}

          {/* Error Message */}
          {error && <p className="invp-error-message invp-print-hide">{error}</p>}

          {/* Success Message */}
          {saveSuccess && (
              <div className="invp-success-message invp-print-hide">
                Invoice saved successfully!
              </div>
          )}

          {/* Action Buttons */}
          <div className="invp-preview-actions invp-print-hide">
            <button
                className="invp-back-btn"
                onClick={onBack}
                disabled={isSubmitting}
            >
              BACK
            </button>
            {!saveSuccess ? (
                <button
                    className="invp-save-btn"
                    onClick={onSave}
                    disabled={isSubmitting}
                >
                  {isSubmitting ? "SAVING..." : "SAVE INVOICE"}
                </button>
            ) : (
                <button
                    className="invp-print-btn"
                    onClick={() => printInvoice(invoiceData)}
                >
                  PRINT INVOICE
                </button>
            )}
          </div>
        </div>
      </div>
  );
};

export default InvoicePreview;